const NumberInput = ({ label, name, value, onChange }) => (
    <label>
        {label}:
        <input type="number" name={name} value={value} onChange={onChange} />
    </label>
);

export default NumberInput;
